enum ExaminationType {
  'All' = 0,
  'Part I' = 1,
  'Part II' = 2,
  'Part III' = 3
}

export const ExamAdminEnum = { ExaminationType }
